var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-dialog',{ref:"contact",staticClass:"contact"},[_c('edit',{attrs:{"fs":_vm.contactFields,"api":"notifications/contactus","title":"Contact Us","customClassName":"none"},on:{"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }